import { type JSX } from 'react'

import { DataAgeLegend } from '@components/storeMap/DataAgeLegend'
import ResetZoomButton from '@components/storeMap/ResetZoomButton'
import TwoDim from '@components/storeMap/floor/2d/TwoDim'
import ThreeDim from '@components/storeMap/floor/3d/ThreeDim'
import StoreMapProvider, { type DimType } from '@components/storeMap/provider/Provider'
import { useStoreMapContext } from '@components/storeMap/provider/StoreMapContext'
import { FloatingToolbar } from '@components/storeMap/toolbar/FloatingToolbar'
import ScanModeBar from '@components/storeMap/toolbar/ScanModeBar'
import { useSelectedDay } from '@hooks/useSelectedDay'

import type { ShelfProducer } from '@components/storeMap/floor/2d/Floor'

function StoreMapContent() {
  const { dimType, isLayerActive, showToolbar } = useStoreMapContext()
  const { dayScan } = useSelectedDay()

  return (
    <div className='relative flex size-full flex-col'>
      <FloatingToolbar />
      {showToolbar && dayScan && <ScanModeBar />}
      {dimType === '2D' && <TwoDim />}
      {dimType === '3D' && <ThreeDim />}
      {isLayerActive('DATA_AGE') && <DataAgeLegend />}
      <ResetZoomButton />
    </div>
  )
}

interface StoreMapProps {
  showToolbar: boolean
  selectedShelfId?: string
  setSelectedShelfId?: (shelfId?: string) => void
  highlightedShelves?: string[]
  dimType?: DimType
  overlays2D?: JSX.Element[]
  overlays3D?: JSX.Element[]
  shelfProducer2D?: ShelfProducer
}

function StoreMap({ showToolbar, highlightedShelves, selectedShelfId, setSelectedShelfId, dimType, overlays3D, overlays2D, shelfProducer2D }: StoreMapProps) {
  return (
    <StoreMapProvider
      showToolbar={showToolbar}
      highlightedShelves={highlightedShelves}
      selectedShelfId={selectedShelfId}
      setSelectedShelfId={setSelectedShelfId}
      dimType={dimType}
      overlays2D={overlays2D}
      overlays3D={overlays3D}
      shelfProducer2D={shelfProducer2D}
    >
      <StoreMapContent />
    </StoreMapProvider>
  )
}

export default StoreMap